window.showPointerAlert = function(msg, e) {
  let overlay = document.getElementById('custom-compare-modal-overlay');
  
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'custom-compare-modal-overlay';
    overlay.className = 'custom-modal-overlay';
    overlay.innerHTML = `
      <div class="custom-alert-modal">
        <button type="button" class="custom-modal-close" onclick="closeCompareAlert()">&times;</button>
        <div class="custom-modal-icon">
          <svg viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path></svg>
        </div>
        <h3 class="custom-modal-title">Warning</h3>
        <p class="custom-modal-text" id="custom-modal-msg"></p>
        <button type="button" class="custom-modal-action" onclick="closeCompareAlert()">Cancel</button>
      </div>
    `;
    document.body.appendChild(overlay);

    window.closeCompareAlert = function() {
      const el = document.getElementById('custom-compare-modal-overlay');
      if (el) el.classList.remove('is-visible');
    };

    overlay.addEventListener('click', function(event) {
      if(event.target === overlay) window.closeCompareAlert();
    });
  }

  document.getElementById('custom-modal-msg').textContent = msg;
  
  requestAnimationFrame(() => {
    overlay.classList.add('is-visible');
  });
};

window.getCompareList = function() {
  try {
    return JSON.parse(localStorage.getItem('fresh_compare_items')) || [];
  } catch (e) {
    return [];
  }
};

window.saveCompareList = function(list) {
  localStorage.setItem('fresh_compare_items', JSON.stringify(list));
  window.updateGlobalCompareCount();
  window.updateProductCardButtonsState();
};

window.updateGlobalCompareCount = function() {
  const list = window.getCompareList();
  const badges = document.querySelectorAll('.global-compare-count');
  badges.forEach(b => {
    b.textContent = list.length;
    b.style.display = list.length > 0 ? 'flex' : 'none';
  });
};

window.updateProductCardButtonsState = function() {
  const list = window.getCompareList();
  const totalCount = list.length;
  const activeCollection = list.length > 0 ? (list[0].collection || 'default') : null;

  document.querySelectorAll('.c2-compare-trigger-btn').forEach(btn => {
    const id = parseInt(btn.getAttribute('data-compare-id'), 10);
    const btnCollection = btn.getAttribute('data-compare-collection') || 'default';
    const exists = list.some(item => item.id === id);

    btn.classList.toggle('is-in-compare', exists);

    let isDifferentCollection = (activeCollection && activeCollection !== btnCollection && !exists);
    let limitReached = (totalCount >= 4 && !exists);

    if (isDifferentCollection || limitReached) {
      btn.classList.add('is-disabled-card-btn');
      btn.style.opacity = '0.5';
      btn.style.cursor = 'not-allowed';
      btn.setAttribute('aria-disabled', 'true');
    } else {
      btn.classList.remove('is-disabled-card-btn');
      btn.style.opacity = '1';
      btn.style.cursor = 'pointer';
      btn.removeAttribute('aria-disabled');
    }
  });
};

window.toggleProductCompare = function(btn, event) {
  if (event) event.preventDefault();
  
  if (btn.classList.contains('is-disabled-card-btn') || btn.hasAttribute('aria-disabled')) {
    const list = window.getCompareList();
    const productCollection = btn.getAttribute('data-compare-collection') || 'default';
    if (list.length > 0) {
      const existingCollection = list[0].collection || 'default';
      if (existingCollection !== productCollection) {
        window.showPointerAlert("Warning, You cannot compare products from different categories, please cancel it below", event);
      } else {
        window.showPointerAlert("You can compare a maximum of 4 products.", event);
      }
    }
    return;
  }

  const id = parseInt(btn.getAttribute('data-compare-id'), 10);
  const productCollection = btn.getAttribute('data-compare-collection') || 'default';
  
  let list = window.getCompareList();
  
  if (list.length > 0) {
    const existingCollection = list[0].collection || 'default';
    if (existingCollection !== productCollection) {
      window.showPointerAlert("Warning, You cannot compare products from different categories, please cancel it below", event);
      return;
    }
  }

  const existingIdx = list.findIndex(item => item.id === id);

  if (existingIdx > -1) {
    list.splice(existingIdx, 1);
  } else {
    if (list.length >= 4) {
      window.showPointerAlert("You can compare a maximum of 4 products.", event);
      return;
    }

    const prodObj = {
      id: id,
      title: btn.getAttribute('data-compare-title'),
      vendor: btn.getAttribute('data-compare-vendor'),
      url: btn.getAttribute('data-compare-url'),
      price: btn.getAttribute('data-compare-price'),
      compare_at_price: btn.getAttribute('data-compare-old-price') || null,
      image: btn.getAttribute('data-compare-image'),
      collection: productCollection,
      metafields: {}
    };
    list.push(prodObj);
  }

  window.saveCompareList(list);
};

document.addEventListener('DOMContentLoaded', () => {
  window.updateGlobalCompareCount();
  window.updateProductCardButtonsState();
});

// Wishlist JS

window.getWishlistList = function() {
  try {
    return JSON.parse(localStorage.getItem('fresh_wishlist_items')) || [];
  } catch (e) {
    return [];
  }
};

window.saveWishlistList = function(list) {
  localStorage.setItem('fresh_wishlist_items', JSON.stringify(list));
  window.updateGlobalWishlistCount();
  window.updateProductCardWishlistState();
};

window.updateGlobalWishlistCount = function() {
  const list = window.getWishlistList();
  const badges = document.querySelectorAll('.global-wishlist-count');
  badges.forEach(b => {
    b.textContent = list.length;
    b.style.display = list.length > 0 ? 'flex' : 'none';
  });
};

window.updateProductCardWishlistState = function() {
  const list = window.getWishlistList();
  document.querySelectorAll('.c2-wishlist-trigger-btn').forEach(btn => {
    const id = parseInt(btn.getAttribute('data-wishlist-id'), 10);
    const exists = list.some(item => item.id === id);
    btn.classList.toggle('is-in-wishlist', exists);
  });
};

window.toggleProductWishlist = function(btn, event) {
  if (event) event.preventDefault();
  
  const id = parseInt(btn.getAttribute('data-wishlist-id'), 10);
  let list = window.getWishlistList();
  const existingIdx = list.findIndex(item => item.id === id);

  if (existingIdx > -1) {
    list.splice(existingIdx, 1);
  } else {
    const prodObj = {
      id: id,
      title: btn.getAttribute('data-wishlist-title'),
      vendor: btn.getAttribute('data-wishlist-vendor'),
      url: btn.getAttribute('data-wishlist-url'),
      price: btn.getAttribute('data-wishlist-price'),
      compare_at_price: btn.getAttribute('data-wishlist-old-price') || null,
      image: btn.getAttribute('data-wishlist-image')
    };
    list.push(prodObj);
  }

  window.saveWishlistList(list);
};

document.addEventListener('DOMContentLoaded', () => {
  window.updateGlobalWishlistCount();
  window.updateProductCardWishlistState();
});


// //licese checker
// (function() {
//     var _0x5f2a = ['bmF0aW9uYWxob21lYXBwbGlhbmNlcy5teXNob3BpZnkuY29t'];
//     var _allowed = atob(_0x5f2a[0]);
//     var _currentDomain = window.location.hostname;
    
//     if (_currentDomain.indexOf(_allowed) === -1) {
//         function createShield() {
//             if (document.getElementById('license-shield')) return;
//             var _shield = document.createElement('div');
//             _shield.id = 'license-shield';
//             _shield.style.position = 'fixed';
//             _shield.style.top = '0';
//             _shield.style.left = '0';
//             _shield.style.width = '100vw';
//             _shield.style.height = '100vh';
//             _shield.style.zIndex = '99999999';
//             _shield.style.background = 'rgba(255, 255, 255, 0.98)';
//             _shield.style.display = 'flex';
//             _shield.style.flexDirection = 'column';
//             _shield.style.justifyContent = 'center';
//             _shield.style.alignItems = 'center';
//             _shield.style.fontFamily = 'sans-serif';
//             _shield.innerHTML = '<h2 style="color:#333;margin-bottom:10px;">Access Denied</h2><p style="color:#666;">This theme is not licensed for this store.</p>';
//             document.body.appendChild(_shield);
//         }

//         document.addEventListener('DOMContentLoaded', function() {
//             createShield();
            
//             var observer = new MutationObserver(function(mutations) {
//                 mutations.forEach(function(mutation) {
//                     if (!document.getElementById('license-shield')) {
//                         createShield();
//                     }
//                 });
//             });
            
//             observer.observe(document.body, { childList: true, subtree: true });
//         });
//     }
// })();


